<script lang="ts" setup>
import { RouterView } from 'vue-router'

import Footer from '@/components/Footer/Footer.vue'
import NavLower from '@/components/NavLower.vue'
import NavUpper from '@/components/NavUpper.vue'
</script>
<template>
  <NavUpper></NavUpper>
  <NavLower></NavLower>
  <RouterView />
  <Footer></Footer>
</template>
